import { usePatchUnlockedVideo } from '@vimeo/use-unlocked-video';

import { useVideoData } from './use-video-data';

export const useEditVideoData = (clipRequestId: string, showcaseId?: number, reviewId?: string) => {
  const [patchVideo, { loading, error }] = usePatchUnlockedVideo();
  const { mutate } = useVideoData(clipRequestId, showcaseId, reviewId);

  const saveViewerPageCommentPreference = async (showComment: boolean) => {
    return patchVideo({
      // @ts-expect-error videoId expects a number, but doesn't account for clipHash strings
      where: { videoId: clipRequestId },
      select: ['page'],
      variables: { page: { comments: showComment } },
    }).then(() => {
      mutate();
    });
  };

  return {
    saveViewerPageCommentPreference,
    loading,
    error,
  };
};
